var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "10px",
    viewBox: "0 0 20 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CFFA8921-B490-4E76-BE59-CA95752BBEB4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-Copy",
    transform: "translate(-1270.000000, -801.000000)",
    fill: "#A8A8A8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(977.000000, 745.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(213.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "right-arrow-(2)",
    transform: "translate(80.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7708496,4.42915295 C19.7706152,4.42891102 19.7704199,4.42862876 19.7701464,4.42838682 L15.687961,0.234836078 C15.3821408,-0.0793173241 14.8874926,-0.0781479686 14.5830787,0.237578015 C14.2787039,0.553263677 14.2798757,1.0638688 14.5856959,1.37806253 L17.3264758,4.19354798 L0.781249612,4.19354798 C0.349765451,4.19354798 0,4.55459657 0,5 C0,5.44540352 0.349765451,5.80645211 0.781249612,5.80645211 L17.3264367,5.80645211 L14.585735,8.62193757 C14.2799148,8.93613129 14.2787429,9.44673642 14.5831178,9.76242208 C14.8875317,10.0781884 15.3822189,10.0792771 15.688,9.76516401 L19.7701855,5.57161327 C19.7704199,5.57137134 19.7706152,5.57108908 19.7708886,5.57084714 C20.076865,5.25560503 20.0758885,4.74334668 19.7708496,4.42915295 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayArrowRight);
export default __webpack_public_path__ + "static/media/gray-arrow-right.dd65aa4c1b16291e4cdddb937520cddc.svg";
export { ForwardRef as ReactComponent };